import { HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';
import { toPrice } from '../../../../utils/parsers';
import { SUPPLEMENT_PER_MONTH_DIVIDER } from '../Cocktail';

export const ShortageTopText: React.FC<{ difference: number } & HTMLProps<HTMLDivElement>> = ({ difference }) => {
    const { t } = useTranslation('pension');
    return (
        <div className="text-bnd-orange flex flex-row items-center mb-4">
            <span className="text-6xl mr-4">!</span>
            <span>
                {t("pension-cocktail-fill-screen-results-shortage-text", {
                    shortage: toPrice(difference, {
                        onlyFullEuros: true,
                        withCurrencySymbol: true,
                    }),
                    incomeExtraRequired: toPrice(difference * SUPPLEMENT_PER_MONTH_DIVIDER, {
                        onlyFullEuros: true,
                        withCurrencySymbol: true,
                    })}
                )}
            </span>
        </div>
    );
};
